/**
 * Values taken from the map UX refresh (glass panels, blue accent, 10px rounding), so this window
 * reads as part of the same map UI. Theme selectors rely on the modal paper's lightTheme/darkTheme class.
 */
export const ACCENT_SYNC = '#0C6DDF'

export const RADIUS_SYNC = '10px'

export const GLASS_SYNC = {
	backdropFilter: 'blur(6px)',
	'.lightTheme &': {
		backgroundColor: 'rgba(255, 255, 255, 0.6)',
	},
	'.darkTheme &': {
		backgroundColor: 'rgba(24, 28, 30, 0.6)',
	},
}

/** A selectable row, as in the map's tools menu: light fill, blue border on hover, blue fill when active. */
export const ITEM_SYNC = {
	borderRadius: RADIUS_SYNC,
	border: '1px solid transparent',
	transition: 'all .2s',
	'.lightTheme &': {
		backgroundColor: '#F7F9FC',
	},
	'.darkTheme &': {
		backgroundColor: 'rgba(255, 255, 255, 0.04)',
	},
	'&:hover': {
		borderColor: 'rgba(12, 109, 223, 0.35)',
	},
	'.lightTheme &.active': {
		backgroundColor: '#E8F1FD',
		borderColor: ACCENT_SYNC,
	},
	'.darkTheme &.active': {
		backgroundColor: 'rgba(12, 109, 223, 0.25)',
		borderColor: '#90caf9',
	},
}

export const FRAME_BORDER_SYNC = '1px solid rgba(0, 0, 0, 0.12)'

export const BUTTON_SHADOW_SYNC = '0 2px 6px rgba(0, 0, 0, 0.25)'

/** A white modal header instead of the app's slate one: the whole window sits on one surface. */
export const HEADER_SYNC = {
	backgroundColor: 'background.paper',
	borderBottom: FRAME_BORDER_SYNC,
	'& .MuiTypography-root': {
		color: 'text.primary',
	},
	'& svg': {
		color: 'text.secondary',
	},
	'& svg path': {
		fill: 'currentColor',
	},
}
